// Modal2.tsx
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useAppSelector } from '../../../../../redux/hooks';
import { getInstances, getInstancesGlobales } from '../../Dashboard/requests/request';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useAuth } from '../../../auth';
import { useAppDispatch } from '../../../../../redux/hooks';
import { DemoModal } from '../../../../Modal_Demo/ViewModalDemo';
import { SetInstance } from '../../../../../redux/feature/InstanceSlice';
import { SetvRF } from '../../../../../redux/feature/VrfSlice';
import { SetConnector } from '../../../../../redux/feature/ConnectorSlice';

const API_URL = process.env.REACT_APP_API_URL
type ID = undefined | null | number


interface Modal2Props {
  showModal: boolean;
  handleClose: () => void;
  setDatos: any
  //setselectvrf:any
  // setconnector:any
}

interface ApiData {
  name: string;
  localSubnet: any;
  RemoteSubnet: any;

  // action:string;
  // mode:string;
  // priority:string

}
type vrf = {
  vendor: string,
  vrf: string
  subscription: (string)
}


type connector = {
  id: string,
  name: string
}
const Modal2: React.FC<Modal2Props> = ({ showModal, handleClose, setDatos }) => {
  /************************************llamadas a la API ********************************************** */
  const [ID, setID] = useState<ID>(undefined)

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  /*****************************************prueba text area */
  const Instance = useAppSelector(state => state.InstanceSlice.id);
  const VRF = useAppSelector(state => state.VrfSlice.id)
  const connector = useAppSelector(state => state.ConnectorSlice.id)

  const dispatch = useAppDispatch();

  const [inputData, setInputData] = useState<string>('');
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)
  // const[Busqueda,setBusquedaa]= useState("")
  const [listvrf, setlistvrff] = useState<vrf[]>([])

  //const [vrfselect,setselectvrff]= useState<any>()
  const [configApplied, setConfigApplied] = useState(false);



  const [Instancia, setInstancia] = useState([{
    id: 0,
    name: " ",
    type: ''

  }])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (FlagReg === true) {
          if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.IPSEC.List')) {
            if (tenant === 0) {
              const instancias = await getInstances(Id, 'Ctx.IPSEC.List', Type, nameregion);
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              }
              else {
                setInstancia(instancias.data)
                if (instancias.data.length > 0) {
                  dispatch(SetInstance(Number(instancias.data[0].id)));
                }


              }
            }
            else {
              const instancias = await getInstancesGlobales(Id, tenant, 'Ctx.IPSEC.List', Type, nameregion);
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              }
              else {

                setInstancia(instancias.data)
                if (instancias.data.length > 0) {
                  dispatch(SetInstance(Number(instancias.data[0].id)));
                }

              }
            }
          }
          else if (Id !== 0 && Id !== -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.IPSEC.List')) {
            if (tenant === 0) {
              const instancias = await getInstances(Id, 'Ctx.IPSEC.List');
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              }
              else {
                setInstancia(instancias.data)
                if (instancias.data.length > 0) {
                  dispatch(SetInstance(Number(instancias.data[0].id)));
                }


              }
            }
            else {
              const instancias = await getInstancesGlobales(Id, tenant, 'Ctx.IPSEC.List');
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              }
              else {

                setInstancia(instancias.data)
                if (instancias.data.length > 0) {
                  dispatch(SetInstance(Number(instancias.data[0].id)));
                }

              }
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [FlagReg, nameregion]
  )
  /////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && Instance !== '') {
          const body =
          {
            instanceId: Number(Instance),
            suscriptionId: Id
          }
          if (tenant !== 0) {
            await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
              .then(res => {
                setlistvrff(res.data)
              })
          }

          else if (tenant === 0) {
            await axios.post(API_URL + '/v1/listVrf', body)
              .then(res => {
                setlistvrff(res.data)
              })
          }

        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Instance, Id])

  const [listConnector, setlisConnector] = useState<connector[]>([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && Instance !== '' && VRF !== undefined && VRF !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Instance) === x.id) {
              type = x.type
            }
          }
          const vrf = listvrf[Number(VRF)]

          const body =
          {
            type: type,
            vrf: vrf
          }
          if (tenant !== 0) {
            await axios.get(API_URL + '/v1/VPN/instances/' + Instance + '/list_connector?tenantId=' + tenant)
              .then(res => {
                setlisConnector(res.data)
              })
          }

          else if (tenant === 0) {
            await axios.get(API_URL + '/v1/VPN/instances/' + Instance + '/list_connector')
              .then(res => {
                setlisConnector(res.data)
              })
          }

        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [VRF])

  ///////////////////////////////////////////////////GLOBAL////////////////////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.IPSEC.List')) {
          if (tenant === 0) {
            const instancias = await getInstances(-1, 'Ctx.IPSEC.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            }
            else {
              setInstancia(instancias.data)
              if (instancias.data.length > 0) {
                dispatch(SetInstance(Number(instancias.data[0].id)));
              }
            }
          }
          else {
            const instancias = await getInstancesGlobales(-1, tenant, 'Ctx.IPSEC.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            }
            else {
              setInstancia(instancias.data)
              if (instancias.data.length > 0) {
                dispatch(SetInstance(Number(instancias.data[0].id)));
              }
            }
          }

        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id, Type]
  )
  /////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Type === 'CloudGlobal' && Instance !== '') {

          const body =
          {
            instanceId: Number(Instance),
            suscriptionId: '-1'
          }
          await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
            .then(res => {
              setlistvrff(res.data)
            })

        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Instance, Id, Type])
  ////////////////////////////
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Instance !== '' && VRF !== undefined && VRF !== '' && Type === 'CloudGlobal') {
          let type
          for (const x of Instancia) {
            if (Number(Instance) === x.id) {
              type = x.type
            }
          }
          const vrf = listvrf[Number(VRF)]

          const body =
          {
            type: type,
            vrf: vrf
          }
          await axios.get(API_URL + '/v1/VPN/instances/' + Instance + '/list_connector?tenantId=' + tenant)
            .then(res => {
              setlisConnector(res.data)
            })

        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Id, VRF])




  //const[connector,setconnectorr]=useState<any>()

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputData(event.target.value);
  };
  //const cambiarstate = (e:any)=>{
  //   setBusquedaa(e.target.value)
  //}
  // const vrfseleccionada = (e:any)=>{
  //   setselectvrff(e.target.value)
  //}
  /*const connectorseleccionado= (e:any)=>{
    setconnectorr(e.target.value)
    }*/

  const [del, setdel] = useState(false)
  useEffect(() => {
    if (configApplied) {
      handleClose(); // Cierra el modal automáticamente
    }
  }, [configApplied]);


  /************************************************************************************ */
  const [swalInput, setSwalInput] = useState('');
  /************************************************************************************ */


  const handleCreateAndSendData = async () => {


    if (VRF === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Please Select a VRF',
      });
      return; // Detener la ejecución si la VRF no está seleccionada
    }
    if (!connector) {
      Swal.fire({
        icon: 'warning',
        title: 'Please Select a Connector',
      });
      return; // Detener la ejecución si el conector no está seleccionado
    }
    if (inputData === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Please add your policies',
      });
      return; // Detener la ejecución si el conector no está seleccionado
    }
    // Divide el texto en líneas y procesa cada línea
    const lines = inputData.split('\n');

    const apiDataArray: ApiData[] = lines.map((line) => {
      const trimmedLine = line.trim();
      // Verifica si la línea está vacía
      if (trimmedLine === '') {
        return null; // Ignora las líneas vacías
      }
      // Divide cada línea en valores
      const values = line.split(',');

      // Crea un objeto ApiData a partir de los valores
      const apiData: ApiData = {
        name: values[0],
        localSubnet: values[1],
        RemoteSubnet: values[2],
        // action:values[5],
        //mode:values[6],
        //priority:values[7]

      };


      return apiData;
    }).filter(Boolean) as ApiData[];


    const vrf = listvrf[Number(VRF)]

    const body = {
      vrf: vrf,
      policy: apiDataArray
    }



    //Se pregunta si se quiere aplicar la config 
    Swal.fire({
      width: '40%',
      position: 'center',
      icon: 'warning',
      title: "Are you sure you want to apply this configuration?",
      html: `
          <p>
          <strong>¡Attention!</strong> You are about to apply new configuration settings.Please verify that the following policies to be implemented are correct:</p>
          <br/>
          <strong style="color: red">This process may take a few seconds, please wait.</strong>
          <br/>
          <br/>
          <pre>Policy Name,Local-ts Subnet,Remote-ts Subnet</pre>
          <pre>${apiDataArray.map(data => `${data.name},${data.localSubnet || ''},${data.RemoteSubnet || ''}`).join('\n')}</pre>
          <br/>
          `,
      input: 'text',
      inputLabel: 'Enter "confirm" to continue...',
      inputValue: swalInput,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Add!',
      preConfirm: (value) => {
        if (!value.toLowerCase().includes('confirm')) {
          Swal.showValidationMessage('The input must contain the word "confirm"');
        } else {
          setSwalInput(value);
        }
      },
    }).then((result) => {

      if (result.isConfirmed) {
        setSwalInput('');

        setdel(true)
        if (tenant === 0) {
          axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/add_bulk_phase_two/' + connector, body).then(res => {
            setConfigApplied(true);
            /********************************************************************** */
            if (res.data.data && res.data.data.length !== 0) {
              // Si hay datos, pero también hay errores, mostrar un mensaje combinado
              if (res.data.error && res.data.error.length !== 0) {
                Swal.fire({
                  icon: 'warning',
                  title: 'An error occurred',
                  html: `<p>Some policies have not been added.</p>
                          <pre>${res.data.error.map((data: any) => `${data.name},${data.localSubnet || ''},${data.RemoteSubnet || ''}`).join('\n')}</pre>
                          <p>The remaining policies have been added correctly.</p>`
                });
                //setBusqueda(Busqueda);
                //setselectvrf(vrfselect);
                //setconnector(connector)
                setDatos(res.data.data);

                setdel(false);
              } else {
                // Solo hay datos, mostrar el mensaje de éxito
                Swal.fire(
                  'Added!',
                  'Your policies have been added.',
                  'success'
                );
                setdel(false);
                //setBusqueda(Busqueda)
                // setselectvrf(vrfselect);
                //setconnector(connector)
                setDatos(res.data.data);

              }
            } else if (res.data.error && res.data.error.length !== 0) {
              // No hay datos, solo hay errores, mostrar el mensaje de advertencia con detalles de los errores
              Swal.fire({
                icon: 'warning',
                title: 'Some policies have not been added.',
                html: `<p>Some segments could not be added</p>
                          <pre>${res.data.error.map((data: any) => `${data.name},${data.localSubnet || ''},${data.RemoteSubnet || ''}`).join('\n')}</pre>`
              });
            }

          })
          /**************************************************** */
        }
        else {
          axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/add_bulk_phase_two/' + connector + '?tenantId=' + tenant, body).then(res => {
            setConfigApplied(true);
            /********************************************************************** */
            if (res.data.data && res.data.data.length !== 0) {
              // Si hay datos, pero también hay errores, mostrar un mensaje combinado
              if (res.data.error && res.data.error.length !== 0) {
                Swal.fire({
                  icon: 'warning',
                  title: 'An error occurred',
                  html: `<p>Some segments could not be added</p>
                              <pre>${res.data.error.map((data: any) => `${data.name},${data.localSubnet || ''},${data.RemoteSubnet || ''}`).join('\n')}</pre>
                              <p>The remaining segments have been added successfully.</p>`
                });
                // setBusqueda(Busqueda)
                //setselectvrf(vrfselect);
                //setconnector(connector)
                setDatos(res.data.data);

                setdel(false);
              } else {
                // Solo hay datos, mostrar el mensaje de éxito
                Swal.fire(
                  'Added!',
                  'Your Policy have been Added.',
                  'success'
                );
                setdel(false);
                // setBusqueda(Busqueda)
                // setselectvrf(vrfselect);
                //setconnector(connector)
                setDatos(res.data.data);

              }
            } else if (res.data.error && res.data.error.length !== 0) {
              // No hay datos, solo hay errores, mostrar el mensaje de advertencia con detalles de los errores
              Swal.fire({
                icon: 'warning',
                title: 'An error occurred',
                html: `<p>Some segments could not be added</p>
                              <pre>${res.data.error.map((data: any) => `${data.name},${data.localSubnet || ''},${data.RemoteSubnet || ''}`).join('\n')}</pre>`
              });
            }


          });
        }
      } else {
        Swal.fire({ title: "The configuration has not been applied!", icon: "info" });
      }
    });


    // Envía los datos a la API mediante Axios

  };


  useEffect(() => {
    return () => {
      setConfigApplied(false); // Restablece configApplied cuando el componente se desmonta
    };
  }, [configApplied]);


  useEffect(() => {
    if (Instance) {
      dispatch(SetvRF(''));
      dispatch(SetConnector(''));
    }
  }, [Instance])

  useEffect(() => {
    if (VRF) {
      setlisConnector([])
    }
  }, [VRF])

  const { currentUser } = useAuth()


  useEffect(() => {
    if (!showModal) {
      setInputData('')

    }
  }, [showModal])


  return (
    <div>
      <div className={`modal fade ${showModal ? 'show' : ''}`} tabIndex={-1} aria-labelledby="exampleModalLabel2" aria-hidden={!showModal}>
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel2"></h5>
              <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {/* Campos solicitud */}
              <h1 className='text-marino fw-bolder  mb-3 f-titulo fs-md'>Add IPSec Segments</h1>

              <br />
              <label className='form-label f-bold fs-p text-marino  required form-label' >Instance</label>
              <select className="form-select border-gray-300 f-parrafo fs-p text-dk text-center " aria-label="Select example"
                onChange={e => dispatch(SetInstance(Number(e.target.value)))} value={Instance}>
                <option disabled selected hidden defaultValue={0}>Select an Instance </option>
                {Instancia.length === 0 && <option disabled selected hidden>No data</option>}
                {Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && Instancia.map((ins: any, x: any) =>
                  <option key={x} value={ins.id}>{ins.name}</option>
                )
                }
                {Type === 'CloudGlobal' && Instancia.map((ins: any, x: any) =>
                  <option key={x} value={ins.id}>{ins.name}</option>
                )
                }
              </select>
              <div className="row">
                <div className='col'>
                  <label className='form-label  text-marino  required form-label' >VRF</label>
                  <select className="form-select border-gray-300 f-parrafo  text-dk text-center w-200px" aria-label="Select example"
                    onChange={e => dispatch(SetvRF(Number(e.target.value)))} value={VRF}>
                    {listvrf?.length === 0 ? <option key={'x'} className='text-danger bg-info' hidden>No VRF</option> : <option hidden>Select an VRF </option>}

                    {Instance !== '' && Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                      <>
                        {!vrf.vrf && <option key={i} value={i}>Main</option>}
                        {vrf.vrf && <option key={i} value={i}>{vrf.vrf}</option>}
                      </>
                    )
                    }

                    {Instance !== '' && Type === 'CloudGlobal' && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                      <>
                        {!vrf.vrf && <option key={i} value={i}>Main({vrf.subscriptions})</option>}
                        {vrf.vrf && <option key={i} value={i}>{vrf.vrf}({vrf.subscriptions})</option>}
                      </>
                    )
                    }
                  </select>
                </div>
                <div className='col'>
                  <label className='form-label  text-marino  required form-label' >Connector</label>
                  <select className="form-select border-gray-300 f-parrafo  text-dk text-center w-200px" aria-label="Select example"
                    onChange={e => dispatch(SetConnector(e.target.value))} value={connector}>

                    {listConnector?.length === 0 ? <option key={'c'} className='text-danger bg-info' hidden>No Connector</option> : <option hidden>Select an Connector </option>}

                    {Instance !== '' && Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && listConnector.length !== 0 && listConnector?.map((con: any, i: any) =>
                      <>
                        {con.name !== '' && <option key={i} value={con.id}>{con.name}</option>}
                      </>
                    )
                    }

                    {Instance !== '' && Type === 'CloudGlobal' && listConnector.length !== 0 && listConnector?.map((con: any, i) =>
                      <>
                        {con.name !== '' && <option key={i} value={con.id}>{con.name}</option>}

                      </>
                    )
                    }
                  </select>
                </div>
              </div>
              <br />


              <div className='f-parrafo'>
                <p className='text-center fw-bolder'> Instructions</p>
                <p>Add the policies you want one per line in the following order separated by comma: (,).</p>
                <br />
                <p className='text-center'><strong className='text-info'>Security Policy Name,Local_ts_Subnet,Remote_ts_Subnet.</strong></p>
                <br />
                <p className='text-center'>
                  Example:
                  <p>Policy_Name,0.0.0.0/0,0.0.0.0/0</p>

                </p>

                <label className='form-label fw-bolder text-dark fs-6 mb-0' htmlFor="descripcion">Policys</label>
                <textarea
                  value={inputData}
                  onChange={handleInputChange}
                  className="form-control form-control-solid border-primary border-active"
                  placeholder="This is an example of bulk: 
                    Net1-example,0.0.0.0/00,0.0.0.0/00"
                  required
                  rows={10}
                  cols={40}
                  id='Descripcion'
                />
              </div>
              <br />

              {currentUser?.is_demo !== true && <div className='row'>
                <div className='col'>
                  <button id='kt_sign_in_submit' onClick={handleCreateAndSendData}>{del ? 'Adding...' : 'Add'}{del && <span className='spinner-border spinner-border-sm align-middle ms-2'></span>}
                  </button>
                  <button
                    className='btn-cancel btn border border-pink text-pink'
                    onClick={handleClose}
                    style={{ marginLeft: "10px", width: '200px' }}
                  >
                    Cancel
                  </button>
                </div>
              </div>}

              {currentUser?.is_demo === true && <div className="d-flex justify-content-center">
                <button onClick={() => setID(null)} type='submit' id='kt_sign_in_submit'
                >{del ? 'Adding...' : 'Add'}</button>

              </div>}

            </div>

          </div>
        </div>
      </div>
      {showModal && <div className='modal-backdrop fade show'></div>}
      {ID !== undefined && <DemoModal setID={setID} id={ID} />}

    </div>
  );
};

export default Modal2;